import { Injectable } from '@angular/core';
import { Questionnaire } from '../data-models/questionnaire';
import { map, take } from 'rxjs/operators';
import { Database, endAt, equalTo, get, orderByChild, query, ref, startAt, update } from '@angular/fire/database';
import { Auth } from '@angular/fire/auth';
import { Observable, from } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private db: Database, public afAuth: Auth) { }

  updateQuestionnaire(questionnaire: Questionnaire) {
    const questionnaireRef = ref(this.db, `/Questionnaires/${questionnaire.key}`);

    // update returns a Promise, wrap it with `from` to return an Observable
    return update(questionnaireRef, questionnaire);
  }

  fetchQuestionnaire(questionnaireKey: string): Observable<Questionnaire & { key: string }> {
    const questionnaireRef = ref(this.db, `/Questionnaires/${questionnaireKey}`);

    // `get()` returns a Promise, wrap it with `from()` to make it Observable
    return from(get(questionnaireRef)).pipe(
      map(snapshot => ({ key: snapshot.key!, ...snapshot.val() } as Questionnaire & { key: string }))
    );
  }

  fetchQuestionnaires(): Observable<(Questionnaire & { key: string })[]> {
    const questionnairesRef = query(
      ref(this.db, '/Questionnaires/'),
      orderByChild('isExit'),
      equalTo(true)
    );

    return from(get(questionnairesRef)).pipe(
      map(snapshot => {
        const result: (Questionnaire & { key: string })[] = [];
        snapshot.forEach(childSnap => {
          result.push({ key: childSnap.key!, ...childSnap.val() });
        });
        return result;
      })
    );
  }

  fetchAllQuestionnaires(): Observable<(Questionnaire & { key: string })[]> {
    const questionnairesRef = ref(this.db, '/Questionnaires/');

    return from(get(questionnairesRef)).pipe(
      map(snapshot => {
        const result: (Questionnaire & { key: string })[] = [];
        snapshot.forEach(childSnap => {
          result.push({ key: childSnap.key!, ...childSnap.val() });
        });
        return result;
      })
    );
  }

  getQuestionnaire(
    questionnaireKey: string,
    tenantKey: string,
    selectedEntityKey: string,
    startTime?: string,
    endTime?: string
  ): Observable<any[]> {
    const baseRef = ref(this.db, `/QuestionnaireAnalysis/${tenantKey}/${selectedEntityKey}/${questionnaireKey}`);

    if (startTime && endTime) {
      const q = query(
        baseRef,
        orderByChild('submittedQueryDate'),
        startAt(startTime),
        endAt(endTime)
      );

      return from(get(q)).pipe(
        map(snapshot => {
          const result: any[] = [];
          snapshot.forEach(childSnap => {
            result.push({ key: childSnap.key!, ...childSnap.val() });
          });
          return result;
        })
      );
    } else {
      return from(get(baseRef)).pipe(
        map(snapshot => {
          const result: any[] = [];
          snapshot.forEach(childSnap => {
            result.push({ key: childSnap.key!, ...childSnap.val() });
          });
          return result;
        })
      );
    }
  }

}
